import React, { memo } from "react";
import { CarouselItem } from "@/components/ui/carousel";
import GalleryLightbox from "@/components/ui/Gallery/gallery-light-box";
import BackgroundImage from "@/components/ui/layout/background-image";
import { cls, cn } from "@/lib/utils";

interface ProjectGalleryItemProps {
  url: string;
  onLoad?: React.ReactEventHandler<HTMLImageElement> | undefined;
}

function ProjectGalleryItem({ url, onLoad }: ProjectGalleryItemProps) {
  const [imageError, setImageError] = React.useState<string | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleGetError = React.useCallback((error: string) => {
    setImageError(error);
  }, []);

  const handleOnClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOnOpen = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  if (imageError) {
    return null;
  }

  return (
    <>
      <GalleryLightbox
        src={url}
        alt={`Gallery image: ${url}`}
        isOpen={isOpen}
        onClose={handleOnClose}
      />

      <CarouselItem
        key={url}
        className={cn(cls`pl-5 basis-full md:basis-4/5 aspect-4/3`)}
        onClick={handleOnOpen}
      >
        <BackgroundImage
          src={url}
          alt={`house image: ${url}`}
          fill
          sizes="100%"
          overlay="bg-black/10"
          motionProps={{ initial: { opacity: 0 }, animate: { opacity: 1 } }}
          imageProps={{
            getError: handleGetError,
            skeletonClassName: "bg-primary",
            style: { objectFit: "contain" },
            onLoad,
            showSkeleton: false,
          }}
          className="rounded-lg"
        >
          {/* Future floating text or overlays can be added here */}
        </BackgroundImage>
      </CarouselItem>
    </>
  );
}

export default memo(ProjectGalleryItem);
